import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  contacts: [],
  loading: false,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CONTACTS_BEGIN:
    case actionTypes.FETCH_CONTACT_BEGIN:
    case actionTypes.UPDATE_CONTACT_BEGIN:
    case actionTypes.ADD_CONTACT_BEGIN:
      return updateObject(state, { loading: true, error: null });
    case actionTypes.ADD_CONTACT_FAILED:
      return updateObject(state, {
        loading: false,
        error: action.payload.error
      });
    case actionTypes.FETCH_CONTACT_FAILED:
    case actionTypes.UPDATE_CONTACT_FAILED:
      return updateObject(state, {
        loading: false,
        error: action.payload.error,
        contact: null
      });
    case actionTypes.FETCH_CONTACTS_FAILED:
      return updateObject(state, {
        loading: false,
        error: action.payload.error,
        contacts: null
      });
    case actionTypes.FETCH_CONTACTS_SUCCESS:
      return updateObject(state, {
        loading: false,
        contacts: action.payload.contacts
      });
    case actionTypes.FETCH_CONTACT_SUCCESS:
      return updateObject(state, {
        loading: false,
        contact: action.payload.contact
      });
    case actionTypes.UPDATE_CONTACT_SUCCESS:
      var updatedContacts = state.contacts.map((item, index) => {
        if (item.id !== action.payload.contact.id) {
          return item;
        }
        
        return { ...item, ...action.payload.contact };
      });
      
      return updateObject(state, {
        loading: false,
        contacts: updatedContacts,
        contact: action.payload.contact
      });
    case actionTypes.ADD_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        contacts: [
          ...state.contacts.slice(0, 0),
          action.payload.contact,
          ...state.contacts.slice(0)
        ]
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/reducers/contact.js